import { authHttp } from '../http'
import * as routes from '../../routes/patio.routes'
import { errorHandler } from '../../../util/error.service'

export async function getTomadas(tp_id) {
  try {
    const { data } = await authHttp().get(routes.urlGetTomadas(tp_id))
    return data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function getTomadasActived(tp_id) {
  try {
    const { data } = await authHttp().get(routes.urlGetTomadasActived(tp_id))
    return data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function saveTomada(payload) {
  try {
    const { data } = await authHttp().post(routes.urlPostTomada, payload)
    return data
  } catch (error) {
    throw errorHandler(error)
  }
}
